<template>
    <div class="canvas">
        <div class="canvas-out mt-30">
            <div  v-for="item, index in list" :key="index" class="list" >
            <el-row :gutter="20" class="lists">
                <el-col :span="6" class="list-time">
                    <div class="time1">{{item.showDate?item.showDate.substring(8, 10):''}}</div>  
                    <div class="time2">{{item.showDate?item.showDate.substring(0, 7):''}}</div>
                </el-col>
                <el-col :span="2"><div class="gekai"></div></el-col>
                <el-col :span="16" class="list-text">
                    <div class="list-title line1">{{item.title}}</div> 
                    <!-- <div class="list-content line2"><span v-html="typeof(item.content)?item.content:''" ></span></div>  -->
                </el-col>
            </el-row>
            <div class="link"  @click="handleDetail(item.docId)">
                <span class="link-text">查看详情</span>
                <img class="link-img"  src="../../assets/images/newHome/jiantao.png" alt="">
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'info-list',
    props:{
        list:[]
    },
    data () {
        return {}
    },
    methods: {
        handleDetail(val){
            this.$emit('handleDetail', val)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './XThree.scss'

</style>
